import type { FutureConfig } from 'react-router-dom'

export const ROUTER_FUTURE: Partial<FutureConfig> = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
}
